import { render, staticRenderFns } from "./Wikilink.vue?vue&type=template&id=9c9eeb0a"
import script from "./Wikilink.vue?vue&type=script&lang=js"
export * from "./Wikilink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports